<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import EasySlider from "vue-easy-slider";
import Vue from "vue";
import moment from "moment";
import ScrollLoader from "vue-scroll-loader";
import VueIframe from "vue-iframes";

Vue.use(EasySlider);
Vue.use(ScrollLoader);
Vue.use(VueIframe);
//import axios from 'axios';
//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "News Feeds",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      iframeWidth: "100%",
      iframeHeight: "100%",
      iframeScrolling: "auto",
      moment,
      exporting: false,
      showSidebar: false,
      active_el: 1,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      perPage: perPage || 2,
      skip: 0,
      limit: 10,
      like_users: [],
      seen: true,
      loadMore: true,
      scrolled: false,
      is_loader: false,
      search: "",
      admin_image_url: process.env.VUE_APP_MIX_BASE_URL + "media/admin/original/",
      image_url: process.env.VUE_APP_MIX_BASE_URL + "images/download.png",
      user_image: process.env.VUE_APP_MIX_BASE_URL + "images/user.png",
      company_image: process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png",
      status: status == undefined ? "1" : status,
      requestData: {
        total_record: 10,
        skip: 0,
      },
      data: {
        data: "",
      },
      fields: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "post_description",
          label: this.$t("companyManagement.list.description"),
          sortable: true,
        },
        {
          key: "is_active",
          label: this.$t("userManagement.list.status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.$t("companyManagement.list.action"),
          sortable: false,
        },
      ],
    };
  },

  computed: mapGetters("history", [
    "loading",
    "postCount",
    "postData",
    "posts",
    "paginations",
  ]),
  mounted() {
    //let orderBy = this.sortDesc ? "desc" : "asc";
    //let page = 1;
    // setTimeout(function () {
    //   this.getPosts();
    // }, 1500);

    this.getPosts();
  },
  methods: {
    ...mapActions("history", [
      "getPostList",
      "getExportCSVData",
      "getPostListData",
      "postVotes",
      "showPost",
      "likePost",
      "repost",
    ]),
    ...mapActions("post", ["deletePost"]),
    getPosts() {
      if (!this.scrolled && !this.is_loader) {
        this.is_loader = true;
        this.getPostList({
          requestData: this.requestData,
        }).then((data) => {
          this.is_loader = false;
          if (data.length > 0) {
            this.requestData.skip += 10;
            this.loadMore = false;
          } else {
            console.log("no data");
          }
        });
      }
    },
    loaderMethod() {
      this.getPosts();
    },
    activate: function (el) {
      this.active_el = el;
    },

    getToggelData(id) {
      this.showPost(id).then((res) => {
        this.like_users = res.data.like_users
          .concat(res.data.like_companies)
          .concat(res.data.like_admin);
        this.showSidebar = !this.showSidebar;
      });
    },

    imageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/download.png";
    },
    companyimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png";
    },
    userimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/user.png";
    },
    onLoad(frame) {
      this.myIframe = frame.contentWindow;
    },
    likes(post_id) {
      this.likePost(post_id).then((res) => {
        if (res.success) {
          this.getPostListDataName();
          this.getPosts();
        }
      });
    },
    comments(post_id) {
      this.$router.push({
        name: "newsfeeds.show",
        params: { id: post_id },
        query: { seen: 1 },
      });
    },
    getRepostData(id) {
      this.showPost(id).then((res) => {
        if (res) {
          this.$router.push({
            name: "company.newsfeeds.show",
            params: { id: id },
          });
        }
      });
    },
    getPostListDataName(){
      this.requestData.skip = 0
        this.is_loader = true;
        this.getPostListData({
          requestData: this.requestData,
        }).then((data) => {
          this.is_loader = false;
          if (data.length > 0) {
            this.loadMore = false;
          }
        });
    },
    // Posts delete
    deletePostId(id) {
      if (confirm("Do you really want to delete?")) {
        this.deletePost(id).then((res) => {
          if (res.success) {
            this.getPostListDataName();
          }
        });
      }
    },

    postVote(postId,vote) {
      console.log('postId,vote',postId,vote)
      this.postVotes({postId,vote}).then((res) => {
          if (res.success) {
            this.getPostListDataName();
          }
        });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3"></div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">News Feeds</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main justify-content-center row" id="feed-main-div">
      <div class="col-lg-8" v-if="posts.length > 0">
        <div class="card" v-for="post in posts" :key="post.id">
          <div class="card-body" style="padding-bottom: 0px !important">
            <div class="justify-content-center row">
              <div class="col-xl-12">
                <div>
                  <div v-if="post.is_company == 0 && post.user" :requestData="requestData" >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        width: 100% !important;
                        justify-content: space-between;
                      "
                    >
                      <div style="display: flex; align-items: center">
                        <b-avatar
                          variant="info"
                          :src="post.user.image_path + '/' + post.user.image"
                          class="mr-3"
                          v-if="post.user.image"
                        ></b-avatar>
                        <b-avatar
                          variant="info"
                          :src="user_image"
                          class="mr-3"
                          v-else
                        ></b-avatar>
                        <div style="display: grid">
                          <router-link
                            :to="{
                              name: 'newsfeeds.show',
                              params: { id: post.id },
                            }"
                            class="text-dark"
                            ><span class="font-size-15 mr-auto">{{
                              post.user.name
                            }}</span></router-link
                          >

                          <small v-if="post.created_at" class="text-muted">{{
                            moment(post.created_at).fromNow()
                          }}</small>
                          <small v-else class="text-muted">-</small>
                        </div>
                      </div>
                      <div>
                        <a
                          @click="deletePostId(post.id)"
                          href="javascript:void(0)"
                        >
                          <i class="bx bx-trash align-middle text-muted me-1 bx-sm"></i>
                        </a>
                      </div>
                    </div>
                    <input type="hidden" :value="post.id" />
                    <div v-if="!post.repost_id">
                      <!-- post_description -->
                      <div v-if="post && post.post_description !== null && post.post_description !== ''">
                        <div
                          v-html="post.post_description"
                          id="app"
                          style="white-space: pre-wrap"
                          class="text-dark pt-3"
                          v-if="post.post_description.length < 500"
                        ></div>
                        <div
                          v-html="post.post_description.substring(0, 500) + '..'"
                          id="app"
                          style="white-space: pre-wrap"
                          class="text-dark pt-3"
                          v-else
                        ></div>
                        <div v-if="post.post_description.length > 500" class="mb-2">
                          <router-link
                            :to="{
                              name: 'newsfeeds.show',
                              params: { id: post.id },
                            }"
                            class="text-primary"
                            >Read more <i class="mdi mdi-arrow-right"></i
                          ></router-link>
                        </div>
                      </div>

                      <div v-if="post.website_url || post.posts_images.length > 0 && post.type !== 'Poll'">
                        <div class="position-relative mb-3 mt-3" v-if="post.website_url">
                          <div class="repost-border1">
                            <a
                              :href="post.website_url"
                              class="text-primary"
                              target="_blank"
                            >
                              <div class="" style="width: 100% !important">
                                <div
                                  style="
                                    display: flex;
                                    align-items: center;
                                    width: 100% !important;
                                    justify-content: space-between;
                                  "
                                >
                                  <div style="display: flex; align-items: center">
                                    <img
                                      :src="post.website_detail.website_image"
                                      alt=""
                                      v-if="post.website_detail.website_image"
                                      style="width: 100% !important; object-fit: cover"
                                      @error="companyimageNotFound"
                                    />
                                  </div>
                                </div>
                                <div
                                  style="
                                    background-color: #e8e8e8;
                                    width: 100% !important;
                                    object-fit: cover;
                                    padding: 10px;
                                  "
                                >
                                  <span
                                    style="color: #000"
                                    class="text-dark"
                                    v-if="post.website_detail.website_title"
                                  >
                                    <h6>
                                      {{ post.website_detail.website_title }}
                                    </h6>
                                  </span>
                                  <span
                                    style="color: #000"
                                    class="text-dark"
                                    v-if="post.website_detail.website_description"
                                  >
                                    {{ post.website_detail.website_description }}
                                  </span>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div class="position-relative mb-3 mt-3" v-else>
                          <div v-if="post.posts_images.length > 1">
                            <slider animation="fade" height="400px" width="auto">
                              <slider-item
                                v-for="(image, index) in post.posts_images"
                                :key="index"
                              >
                                <img
                                  :src="image.image_path + '/' + image.image"
                                  width="665px;"
                                  style="height: 400px !important"
                                  @error="imageNotFound"
                                />
                              </slider-item>
                            </slider>
                          </div>
                          <div v-else-if="post.posts_images.length == 1">
                            <img
                              :src="
                                post.posts_images[0].image_path +
                                '/' +
                                post.posts_images[0].image
                              "
                              alt=""
                              class="img-thumbnail"
                              v-if="post.posts_images[0].type == 'Image'"
                              width="100%"
                              @error="imageNotFound"
                            />
                            <!-- style="height: 400px !important; width: 100% !important" -->
                            <video
                              style="width: 100% !important; object-fit: cover"
                              v-if="post.posts_images[0].type == 'Video'"
                              controls
                              :src="
                                post.posts_images[0].image_path +
                                '/' +
                                post.posts_images[0].image
                              "
                            ></video>
                            <!-- height: 320px !important; -->
                            <!-- <vue-iframe
                                v-if="post.posts_images[0].type == 'File'"
                                :src="
                                  post.posts_images[0].image_path +
                                  '/' +
                                  post.posts_images[0].image
                                "
                                allow="camera *; geolocation *; microphone *; autoplay *"
                                frame-id="my-ifram"
                                @load="onLoad"
                                name="my-frame"
                                :scrolling="iframeScrolling"
                                :width="iframeWidth"
                                :height="iframeHeight"
                              /> -->

                            <div
                              class="embed-responsive embed-responsive-16by9"
                              v-if="post.posts_images[0].type == 'File'"
                              style="height: 250px !important"
                            >
                              <iframe
                                class="embed-responsive-item vue_frame"
                                :src="
                                  post.posts_images[0].image_path +
                                  '/' +
                                  post.posts_images[0].image
                                "
                              ></iframe>
                            </div>
                            <!-- <span v-if="post.posts_images[0].type == 'File'">{{
                                post.posts_images[0].image
                              }}</span> -->
                          </div>
                          <div v-else>
                            <img
                              :src="image_url"
                              alt=""
                              class="img-thumbnail"
                              width="100%"
                            />
                            <!-- style="height: 400px !important" -->
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="post.type == 'Poll'">
                          <div class="position-relative pt-3 pb-2 pl-3">
                            <div class="border p-1 box-sha ">
                              <h6 class="p-1"> {{ post.question }}</h6>
                              <div>
                                <div v-if="!post.is_voted">
                                  <div v-for="(option, index) in post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                    <div @click="postVote(post.id,option)">{{ option }}</div>
                                  </div>
                                </div>
                                <div v-if="post.is_voted">
                                  <div  v-for="(vote,index) in post.votes" :key="index">
                                    <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                    <template v-if="((vote/post.votes_count) * 100).toFixed(2) > 0">
                                      <b-progress :max="100" height="1rem" animated>
                                        <b-progress-bar :value="((vote/post.votes_count) * 100).toFixed(2)" >
                                          <strong>{{ ((vote/post.votes_count) * 100).toFixed(2) }}%</strong>
                                        </b-progress-bar>
                                      </b-progress>
                                    </template>
                                    <template v-else>
                                      <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                        <p class="text-center"><strong>0%</strong></p>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <h6 class="mt-2 vote-count p-1"> {{ post.votes_count }} Votes</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ul
                        class="list-inline mt-3 mb-3"
                        style="display: flex; justify-content: space-between"
                      >
                        <li class="list-inline-item me-3">
                          <a
                            class="text-muted"
                            href="javascript:void(0)"
                            @click="getToggelData(post.id)"
                            ><i class="bx bx-like align-middle text-muted me-1"></i>
                            {{
                              post.like_users.length +
                              post.like_companies.length +
                              post.like_admin.length
                            }}
                            Likes</a
                          >
                        </li>
                        <li class="list-inline-item me-3 ml-5">
                          <a
                            class="text-muted"
                            :href="'/company/newsfeeds/show/' + post.id"
                          >
                            <i
                              class="bx bx-comment-dots align-middle text-muted me-1"
                            ></i>
                            {{ post.comments.length }} Comments</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div v-else class="pb-3 pt-3">
                      <div v-if="post.repost_id && post.parent_post_data">
                        <div v-if="post && post.post_description !== null && post.post_description !== ''">
                          <div
                            v-html="post.post_description"
                            id="app"
                            style="white-space: pre-wrap"
                            class="text-dark pb-3"
                            v-if="post.post_description.length < 500"  
                          ></div>

                          <div
                            v-html="
                              post.post_description.substring(
                                0,
                                500
                              ) + '..'
                            "
                            id="app"
                            style="white-space: pre-wrap"
                            class="text-dark pb-3"
                            v-else
                          ></div>
                          <div
                            v-if="post.post_description.length > 500"
                            class="mb-2"
                          >
                            <router-link
                              :to="{
                                name: 'company.newsfeeds.show',
                                params: { id: post.id },
                              }"
                              class="text-primary"
                              >Read more <i class="mdi mdi-arrow-right"></i
                            ></router-link>
                          </div>
                        </div>
                        <div class="repost-border">
                          <a
                            class="text-dark"
                            href="javascript:void(0)"
                            @click="getRepostData(post.repost_id)"
                          >
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                width: 100% !important;
                                justify-content: space-between;
                                padding-left: 15px;
                                padding-right: 15px;
                                padding-top: 15px;
                              "
                            >
                              <div
                                style="display: flex; align-items: center"
                                v-if="
                                  post.parent_post_data.company &&
                                  post.parent_post_data.is_company == 1
                                "
                              >
                                <b-avatar
                                  variant="info"
                                  :src="
                                    post.parent_post_data.company.image_path +
                                    '/' +
                                    post.parent_post_data.company.image
                                  "
                                  class="mr-3"
                                  v-if="post.parent_post_data.company.image"
                                ></b-avatar>
                                <b-avatar
                                  variant="info"
                                  :src="company_image"
                                  class="mr-3"
                                  v-else
                                ></b-avatar>
                                <div style="display: grid">
                                  <span class="font-size-15 mr-auto text-dark">{{
                                    post.parent_post_data.company.name
                                  }}</span>
                                  <small
                                    v-if="post.parent_post_data.created_at"
                                    class="text-muted"
                                    >{{
                                      moment(post.parent_post_data.created_at).fromNow()
                                    }}
                                  </small>
                                  <small v-else class="text-muted">-</small>
                                </div>
                              </div>
                              <div
                                style="display: flex; align-items: center"
                                v-if="
                                  post.parent_post_data.user &&
                                  post.parent_post_data.is_company == 0
                                "
                              >
                                <b-avatar
                                  variant="info"
                                  :src="
                                    post.parent_post_data.user.image_path +
                                    '/' +
                                    post.parent_post_data.user.image
                                  "
                                  class="mr-3"
                                  v-if="post.parent_post_data.user.image"
                                ></b-avatar>
                                <b-avatar
                                  variant="info"
                                  :src="user_image"
                                  class="mr-3"
                                  v-else
                                ></b-avatar>
                                <div style="display: grid">
                                  <span class="font-size-15 mr-auto text-dark">{{
                                    post.parent_post_data.user.name
                                  }}</span>

                                  <small
                                    v-if="post.parent_post_data.created_at"
                                    class="text-muted"
                                    >{{
                                      moment(post.parent_post_data.created_at).fromNow()
                                    }}</small
                                  >
                                  <small v-else class="text-muted">-</small>
                                </div>
                              </div>
                            </div>
                            <div class="pt-2 pl-3 pr-3 pb-2">
                              <!-- post_description -->
                              <div v-if="post && post.parent_post_data.post_description !== null && post.parent_post_data.post_description !== ''">
                                <div
                                  v-html="post.parent_post_data.post_description"
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark pt-3"
                                  v-if="post.parent_post_data.post_description.length < 500"
                                ></div>
                                <div
                                  v-html="
                                    post.parent_post_data.post_description.substring(
                                      0,
                                      500
                                    ) + '..'
                                  "
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark pt-3"
                                  v-else
                                ></div>
                                <div
                                  v-if="post.parent_post_data.post_description.length > 500"
                                  class="mb-2"
                                >
                                  <router-link
                                    :to="{
                                      name: 'company.newsfeeds.show',
                                      params: { id: post.id },
                                    }"
                                    class="text-primary"
                                    >Read more <i class="mdi mdi-arrow-right"></i
                                  ></router-link>
                                </div>
                              </div>
                            </div>
                          </a>
                          <div class="pt-2 pl-3 pr-3 pb-2">
                            <div v-if="post.parent_post_data.website_url || post.parent_post_data.posts_images.length > 0 && post.parent_post_data.type !== 'Poll'" >
                              <div
                                class="position-relative mb-3 mt-3"
                                v-if="post.parent_post_data.website_url"
                              >
                                <div class="repost-border1">
                                  <a
                                    :href="post.parent_post_data.website_url"
                                    class="text-primary"
                                    target="_blank"
                                  >
                                    <div class="" style="width: 100% !important">
                                      <div
                                        style="
                                          display: flex;
                                          align-items: center;
                                          width: 100% !important;
                                          justify-content: space-between;
                                        "
                                      >
                                        <div style="display: flex; align-items: center">
                                          <img
                                            :src="
                                              post.parent_post_data.website_detail
                                                .website_image
                                            "
                                            alt=""
                                            v-if="
                                              post.parent_post_data.website_detail
                                                .website_image
                                            "
                                            style="
                                              width: 100% !important;
                                              object-fit: cover;
                                            "
                                            @error="companyimageNotFound"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        style="
                                          background-color: #e8e8e8;
                                          width: 100% !important;
                                          object-fit: cover;
                                          padding: 10px;
                                        "
                                      >
                                        <span
                                          style="color: #000"
                                          class="text-dark"
                                          v-if="
                                            post.parent_post_data.website_detail
                                              .website_title
                                          "
                                        >
                                          <h6>
                                            {{
                                              post.parent_post_data.website_detail
                                                .website_title
                                            }}
                                          </h6>
                                        </span>
                                        <span
                                          style="color: #000"
                                          class="text-dark"
                                          v-if="
                                            post.parent_post_data.website_detail
                                              .website_description
                                          "
                                        >
                                          {{
                                            post.parent_post_data.website_detail
                                              .website_description
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>
                              <div class="position-relative mb-3 mt-3" v-else>
                                <div
                                  v-if="post.parent_post_data.posts_images.length > 1"
                                >
                                  <slider animation="fade" height="400px" width="auto">
                                    <slider-item
                                      v-for="(image, index) in post.parent_post_data
                                        .posts_images"
                                      :key="index"
                                    >
                                      <img
                                        :src="image.image_path + '/' + image.image"
                                        width="665px;"
                                        style="height: 400px !important"
                                        @error="imageNotFound"
                                      />
                                    </slider-item>
                                  </slider>
                                </div>
                                <div
                                  v-else-if="
                                    post.parent_post_data.posts_images.length == 1
                                  "
                                >
                                  <!-- height: 320px !important; -->
                                  <video
                                    style="width: 100% !important; object-fit: cover"
                                    v-if="
                                      post.parent_post_data.posts_images[0].type ==
                                      'Video'
                                    "
                                    controls
                                    :src="
                                      post.parent_post_data.posts_images[0].image_path +
                                      '/' +
                                      post.parent_post_data.posts_images[0].image
                                    "
                                  ></video>

                                  <img
                                    :src="
                                      post.parent_post_data.posts_images[0].image_path +
                                      '/' +
                                      post.parent_post_data.posts_images[0].image
                                    "
                                    alt=""
                                    v-if="
                                      post.parent_post_data.posts_images[0].type ==
                                      'Image'
                                    "
                                    class="img-thumbnail"
                                    width="100%"
                                    @error="imageNotFound"
                                  />
                                  <!-- style="
                                      height: 400px !important;
                                      width: 100% !important;
                                    " -->
                                  <div
                                    class="embed-responsive embed-responsive-16by9"
                                    v-if="
                                      post.parent_post_data.posts_images[0].type ==
                                      'File'
                                    "
                                    style="height: 250px !important"
                                  >
                                    <iframe
                                      class="embed-responsive-item vue_frame"
                                      :src="
                                        post.parent_post_data.posts_images[0]
                                          .image_path +
                                        '/' +
                                        post.parent_post_data.posts_images[0].image
                                      "
                                    ></iframe>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="post.parent_post_data.type == 'Poll'">
                                <div class="position-relative pt-3 pb-2 pl-3">
                                  <div class="border p-1 box-sha ">
                                    <h6 class="p-1"> {{ post.parent_post_data.question }}</h6>
                                    <div>
                                      <div v-if="!post.parent_post_data.is_voted">
                                        <div v-for="(option, index) in post.parent_post_data.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                          <div @click="postVote(post.parent_post_data.id,option)">{{ option }}</div>
                                        </div>
                                      </div>
                                      <div v-if="post.parent_post_data.is_voted">
                                        <div  v-for="(vote,index) in post.parent_post_data.votes" :key="index">
                                          <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                          <template v-if="((vote/post.parent_post_data.votes_count) * 100).toFixed(2) > 0">
                                            <b-progress :max="100" height="1rem" animated>
                                              <b-progress-bar :value="((vote/post.parent_post_data.votes_count) * 100).toFixed(2)" >
                                                <strong>{{ ((vote/post.parent_post_data.votes_count) * 100).toFixed(2) }}%</strong>
                                              </b-progress-bar>
                                            </b-progress>
                                          </template>
                                          <template v-else>
                                            <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                              <p class="text-center"><strong>0%</strong></p>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                      <h6 class="mt-2 vote-count p-1"> {{ post.parent_post_data.votes_count }} Votes</h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <ul
                              class="list-inline"
                              style="display: flex; justify-content: space-between"
                            >
                              <li class="list-inline-item">
                                <i class="bx bx-like align-middle text-muted me-1"></i>
                                {{
                                  post.parent_post_data.like_users.length +
                                  post.parent_post_data.like_companies.length +
                                  post.parent_post_data.like_admin.length
                                }}
                                Likes
                              </li>
                              <li class="list-inline-item">
                                <i
                                  class="bx bx-comment-dots align-middle text-muted me-1"
                                ></i>
                                {{ post.parent_post_data.comments.length }} Comments
                              </li>
                            </ul>
                          </div>
                        </div>
                        <ul
                          class="list-inline mt-3 mb-0"
                          style="display: flex; justify-content: space-between"
                        >
                          <li class="list-inline-item">
                            <a
                              class="text-muted"
                              href="javascript:void(0)"
                              @click="getToggelData(post.id)"
                              ><i class="bx bx-like align-middle text-muted me-1"></i>
                              {{
                                post.like_users.length +
                                post.like_companies.length +
                                post.like_admin.length
                              }}
                              Likes</a
                            >
                          </li>
                          <li class="list-inline-item">
                            <a
                              class="text-muted"
                              :href="'/company/newsfeeds/show/' + post.id"
                            >
                              <i
                                class="bx bx-comment-dots align-middle text-muted me-1"
                              ></i>
                              {{ post.comments.length }} Comments</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>

                    <hr class="" />

                    <ul
                      class="list-inline text-muted"
                      style="display: flex; justify-content: space-between"
                    >
                      <li
                        class="list-inline-item w-50 likes-post"
                        v-if="post.like_admin.length > 0"
                        style="text-align: center"
                      >
                        <a
                          @click="likes(post.id, 1)"
                          class="text-muted"
                          href="javascript:void(0)"
                        >
                          <i class="bx bxs-like align-middle text-muted me-1 bx-sm"></i>
                        </a>
                      </li>
                      <li
                        class="list-inline-item w-50 likes-post"
                        v-else
                        style="text-align: center"
                      >
                        <a
                          @click="likes(post.id)"
                          class="text-muted"
                          href="javascript:void(0)"
                        >
                          <i class="bx bx-like align-middle text-muted me-1 bx-sm"></i>
                        </a>
                      </li>

                      <li class="list-inline-item w-50" style="text-align: center">
                        <a
                          class="text-muted"
                          href="javascript:void(0)"
                          @click="comments(post.id)"
                        >
                          <i
                            class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div v-if="post.is_company == 1 && post.company">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        width: 100% !important;
                        justify-content: space-between;
                      "
                    >
                      <div style="display: flex; align-items: center">
                        <b-avatar
                          variant="info"
                          :src="post.company.image_path + '/' + post.company.image"
                          class="mr-3"
                          v-if="post.company.image !== null"
                        ></b-avatar>
                        <b-avatar
                          variant="info"
                          :src="company_image"
                          class="mr-3"
                          v-else
                        ></b-avatar>
                        <div style="display: grid">
                          <router-link
                            :to="{
                              name: 'newsfeeds.show',
                              params: { id: post.id },
                            }"
                            class="text-dark"
                            ><span class="font-size-15 mr-auto">{{
                              post.company.name
                            }}</span></router-link
                          >

                          <small v-if="post.created_at" class="text-muted">{{
                            moment(post.created_at).fromNow()
                          }}</small>
                          <small v-else class="text-muted">-</small>
                        </div>
                      </div>
                      <div>
                        <a
                          @click="deletePostId(post.id)"
                          href="javascript:void(0)"
                        >
                          <i class="bx bx-trash align-middle text-muted me-1 bx-sm"></i>
                        </a>
                      </div>
                    </div>

                    <input type="hidden" :value="post.id" />
                    <div v-if="!post.repost_id">
                      <!-- post_description -->
                      <div v-if="post && post.post_description !== null && post.post_description !== ''">
                        <div
                          v-html="post.post_description"
                          id="app"
                          style="white-space: pre-wrap"
                          class="text-dark pt-3"
                          v-if="post.post_description.length < 500"
                        ></div>
  
                        <div
                          v-html="post.post_description.substring(0, 500) + '..'"
                          id="app"
                          style="white-space: pre-wrap"
                          class="text-dark pt-3"
                          v-else
                        ></div>
  
                        <div v-if="post.post_description.length > 500" class="mb-2">
                          <router-link
                            :to="{
                              name: 'newsfeeds.show',
                              params: { id: post.id },
                            }"
                            class="text-primary"
                            >Read more <i class="mdi mdi-arrow-right"></i
                          ></router-link>
                        </div>
                      </div>

                      <div v-if="post.website_url || post.posts_images.length > 0 && post.type !== 'Poll'">
                        <div class="position-relative mb-3 mt-3" v-if="post.website_url">
                          <div class="repost-border1">
                            <a
                              :href="post.website_url"
                              class="text-primary"
                              target="_blank"
                            >
                              <div class="" style="width: 100% !important">
                                <div
                                  style="
                                    display: flex;
                                    align-items: center;
                                    width: 100% !important;
                                    justify-content: space-between;
                                  "
                                >
                                  <div style="display: flex; align-items: center">
                                    <img
                                      :src="post.website_detail.website_image"
                                      alt=""
                                      v-if="post.website_detail.website_image"
                                      style="width: 100% !important; object-fit: cover"
                                      @error="companyimageNotFound"
                                    />
                                  </div>
                                </div>
                                <div
                                  style="
                                    background-color: #e8e8e8;
                                    width: 100% !important;
                                    object-fit: cover;
                                    padding: 10px;
                                  "
                                >
                                  <span
                                    style="color: #000"
                                    class="text-dark"
                                    v-if="post.website_detail.website_title"
                                  >
                                    <h6>
                                      {{ post.website_detail.website_title }}
                                    </h6>
                                  </span>
                                  <span
                                    style="color: #000"
                                    class="text-dark"
                                    v-if="post.website_detail.website_description"
                                  >
                                    {{ post.website_detail.website_description }}
                                  </span>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div class="position-relative mb-3 mt-3" v-else>
                          <div v-if="post.posts_images.length > 1">
                            <slider animation="fade" height="400px" width="auto">
                              <slider-item
                                v-for="(image, index) in post.posts_images"
                                :key="index"
                              >
                                <img
                                  :src="image.image_path + '/' + image.image"
                                  width="665px;"
                                  style="height: 400px !important"
                                  @error="imageNotFound"
                                />
                              </slider-item>
                            </slider>
                          </div>
                          <div v-else-if="post.posts_images.length == 1">
                            <img
                              :src="
                                post.posts_images[0].image_path +
                                '/' +
                                post.posts_images[0].image
                              "
                              alt=""
                              v-if="post.posts_images[0].type == 'Image'"
                              class="img-thumbnail"
                              width="100%"
                              @error="imageNotFound"
                            />
                            <!-- style="height: 400px !important; width: 100% !important" -->
                            <!-- height: 320px !important; -->
                            <video
                              style="width: 100% !important; object-fit: cover"
                              v-if="post.posts_images[0].type == 'Video'"
                              controls
                              :src="
                                post.posts_images[0].image_path +
                                '/' +
                                post.posts_images[0].image
                              "
                            ></video>

                            <div
                              class="embed-responsive embed-responsive-16by9"
                              v-if="post.posts_images[0].type == 'File'"
                              style="height: 250px !important"
                            >
                              <iframe
                                class="embed-responsive-item vue_frame"
                                :src="
                                  post.posts_images[0].image_path +
                                  '/' +
                                  post.posts_images[0].image
                                "
                              ></iframe>
                            </div>

                            <!-- <vue-iframe
                              v-if="post.posts_images[0].type == 'File'"
                              :src="
                                post.posts_images[0].image_path +
                                '/' +
                                post.posts_images[0].image
                              "
                              allow="camera *; geolocation *; microphone *; autoplay *"
                              frame-id="my-ifram"
                              @load="onLoad"
                              name="my-frame"
                              :scrolling="iframeScrolling"
                              :width="iframeWidth"
                              :height="iframeHeight"
                            /> -->

                            <!-- <span v-if="post.posts_images[0].type == 'File'">{{
                              post.posts_images[0].image
                            }}</span> -->
                          </div>
                          <div v-else>
                            <img
                              :src="image_url"
                              alt=""
                              class="img-thumbnail"
                              width="100%"
                            />
                            <!-- style="height: 400px !important" -->
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="post.type == 'Poll'">
                          <div class="position-relative pt-3 pb-2 pl-3">
                            <div class="border p-1 box-sha ">
                              <h6 class="p-1"> {{ post.question }}</h6>
                              <div>
                                <div v-if="!post.is_voted">
                                  <div v-for="(option, index) in post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                    <div @click="postVote(post.id,option)">{{ option }}</div>
                                  </div>
                                </div>
                                <div v-if="post.is_voted">
                                  <div  v-for="(vote,index) in post.votes" :key="index">
                                    <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                    <template v-if="((vote/post.votes_count) * 100).toFixed(2) > 0">
                                      <b-progress :max="100" height="1rem" animated>
                                        <b-progress-bar :value="((vote/post.votes_count) * 100).toFixed(2)" >
                                          <strong>{{ ((vote/post.votes_count) * 100).toFixed(2) }}%</strong>
                                        </b-progress-bar>
                                      </b-progress>
                                    </template>
                                    <template v-else>
                                      <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                        <p class="text-center"><strong>0%</strong></p>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <h6 class="mt-2 vote-count p-1"> {{ post.votes_count }} Votes</h6>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <ul
                        class="list-inline mt-3 mb-3"
                        style="display: flex; justify-content: space-between"
                      >
                        <li class="list-inline-item">
                          <a
                            class="text-muted"
                            href="javascript:void(0)"
                            @click="getToggelData(post.id)"
                            ><i class="bx bx-like align-middle text-muted me-1"></i>
                            {{
                              post.like_users.length +
                              post.like_companies.length +
                              post.like_admin.length
                            }}
                            Likes</a
                          >
                        </li>
                        <li class="list-inline-item">
                          <a
                            class="text-muted"
                            :href="'/company/newsfeeds/show/' + post.id"
                          >
                            <i
                              class="bx bx-comment-dots align-middle text-muted me-1"
                            ></i>
                            {{ post.comments.length }} Comments</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="pb-3 pt-3" v-else>
                      <div v-if="post.repost_id && post.parent_post_data">
                        <div v-if="post && post.post_description !== null && post.post_description !== ''">
                          <div
                            v-html="post.post_description"
                            id="app"
                            style="white-space: pre-wrap"
                            class="text-dark pb-3"
                            v-if="post.post_description.length < 500"  
                          ></div>

                          <div
                            v-html="
                              post.post_description.substring(
                                0,
                                500
                              ) + '..'
                            "
                            id="app"
                            style="white-space: pre-wrap"
                            class="text-dark pb-3"
                            v-else
                          ></div>
                          <div
                            v-if="post.post_description.length > 500"
                            class="mb-2"
                          >
                            <router-link
                              :to="{
                                name: 'company.newsfeeds.show',
                                params: { id: post.id },
                              }"
                              class="text-primary"
                              >Read more <i class="mdi mdi-arrow-right"></i
                            ></router-link>
                          </div>
                        </div>
                        <div class="repost-border">
                          <a
                            class="text-dark"
                            href="javascript:void(0)"
                            @click="getRepostData(post.repost_id)"
                          >
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                width: 100% !important;
                                justify-content: space-between;
                                padding-left: 15px;
                                padding-right: 15px;
                                padding-top: 15px;
                              "
                            >
                              <div
                                style="display: flex; align-items: center"
                                v-if="
                                  post.parent_post_data.company &&
                                  post.parent_post_data.is_company == 1
                                "
                              >
                                <b-avatar
                                  variant="info"
                                  :src="
                                    post.parent_post_data.company.image_path +
                                    '/' +
                                    post.parent_post_data.company.image
                                  "
                                  class="mr-3"
                                  v-if="post.parent_post_data.company.image"
                                ></b-avatar>
                                <b-avatar
                                  variant="info"
                                  :src="company_image"
                                  class="mr-3"
                                  v-else
                                ></b-avatar>
                                <div style="display: grid">
                                  <span class="font-size-15 mr-auto text-dark">{{
                                    post.parent_post_data.company.name
                                  }}</span>
                                  <small
                                    v-if="post.parent_post_data.created_at"
                                    class="text-muted"
                                    >{{
                                      moment(post.parent_post_data.created_at).fromNow()
                                    }}
                                  </small>
                                  <small v-else class="text-muted">-</small>
                                </div>
                              </div>
                              <div
                                style="display: flex; align-items: center"
                                v-if="
                                  post.parent_post_data.user &&
                                  post.parent_post_data.is_company == 0
                                "
                              >
                                <b-avatar
                                  variant="info"
                                  :src="
                                    post.parent_post_data.user.image_path +
                                    '/' +
                                    post.parent_post_data.user.image
                                  "
                                  class="mr-3"
                                  v-if="post.parent_post_data.user.image"
                                ></b-avatar>
                                <b-avatar
                                  variant="info"
                                  :src="user_image"
                                  class="mr-3"
                                  v-else
                                ></b-avatar>
                                <div style="display: grid">
                                  <span class="font-size-15 mr-auto text-dark">{{
                                    post.parent_post_data.user.name
                                  }}</span>

                                  <small
                                    v-if="post.parent_post_data.created_at"
                                    class="text-muted"
                                    >{{
                                      moment(post.parent_post_data.created_at).fromNow()
                                    }}</small
                                  >
                                  <small v-else class="text-muted">-</small>
                                </div>
                              </div>
                            </div>
                            <div class="pt-2 pl-3 pr-3 pb-2">
                              <!-- post_description -->
                              <div v-if="post && post.parent_post_data.post_description !== null && post.parent_post_data.post_description !== ''">
                                <div
                                  v-html="post.parent_post_data.post_description"
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark pt-3"
                                  v-if="post.parent_post_data.post_description.length < 500"
                                ></div>
  
                                <div
                                  v-html="
                                    post.parent_post_data.post_description.substring(
                                      0,
                                      500
                                    ) + '..'
                                  "
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark pt-3"
                                  v-else
                                ></div>
                                <div
                                  v-if="post.parent_post_data.post_description.length > 500"
                                  class="mb-2"
                                >
                                  <router-link
                                    :to="{
                                      name: 'company.newsfeeds.show',
                                      params: { id: post.id },
                                    }"
                                    class="text-primary"
                                    >Read more <i class="mdi mdi-arrow-right"></i
                                  ></router-link>
                                </div>
                              </div>
                            </div>
                          </a>
                            <div class="pt-2 pl-3 pr-3 pb-2">
                              <div v-if="post.parent_post_data.website_url || post.parent_post_data.posts_images.length > 0&& post.parent_post_data.type !== 'Poll'" >
                                <div
                                  class="position-relative mb-3 mt-3"
                                  v-if="post.parent_post_data.website_url"
                                >
                                  <div class="repost-border1">
                                    <a
                                      :href="post.parent_post_data.website_url"
                                      class="text-primary"
                                      target="_blank"
                                    >
                                      <div class="" style="width: 100% !important">
                                        <div
                                          style="
                                            display: flex;
                                            align-items: center;
                                            width: 100% !important;
                                            justify-content: space-between;
                                          "
                                        >
                                          <div style="display: flex; align-items: center">
                                            <img
                                              :src="
                                                post.parent_post_data.website_detail
                                                  .website_image
                                              "
                                              alt=""
                                              v-if="
                                                post.parent_post_data.website_detail
                                                  .website_image
                                              "
                                              style="
                                                width: 100% !important;
                                                object-fit: cover;
                                              "
                                              @error="companyimageNotFound"
                                            />
                                          </div>
                                        </div>
                                        <div
                                          style="
                                            background-color: #e8e8e8;
                                            width: 100% !important;
                                            object-fit: cover;
                                            padding: 10px;
                                          "
                                        >
                                          <span
                                            style="color: #000"
                                            class="text-dark"
                                            v-if="
                                              post.parent_post_data.website_detail
                                                .website_title
                                            "
                                          >
                                            <h6>
                                              {{
                                                post.parent_post_data.website_detail
                                                  .website_title
                                              }}
                                            </h6>
                                          </span>
                                          <span
                                            style="color: #000"
                                            class="text-dark"
                                            v-if="
                                              post.parent_post_data.website_detail
                                                .website_description
                                            "
                                          >
                                            {{
                                              post.parent_post_data.website_detail
                                                .website_description
                                            }}
                                          </span>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div class="position-relative mb-3 mt-3" v-else>
                                  <div
                                    v-if="post.parent_post_data.posts_images.length > 1"
                                  >
                                    <slider animation="fade" height="400px" width="auto">
                                      <slider-item
                                        v-for="(image, index) in post.parent_post_data
                                          .posts_images"
                                        :key="index"
                                      >
                                        <img
                                          :src="image.image_path + '/' + image.image"
                                          width="665px;"
                                          style="height: 400px !important"
                                          @error="imageNotFound"
                                        />
                                      </slider-item>
                                    </slider>
                                  </div>
                                  <div
                                    v-else-if="
                                      post.parent_post_data.posts_images.length == 1
                                    "
                                  >
                                    <!-- height: 320px !important; -->
                                    <video
                                      style="width: 100% !important; object-fit: cover"
                                      v-if="
                                        post.parent_post_data.posts_images[0].type ==
                                        'Video'
                                      "
                                      controls
                                      :src="
                                        post.parent_post_data.posts_images[0].image_path +
                                        '/' +
                                        post.parent_post_data.posts_images[0].image
                                      "
                                    ></video>

                                    <img
                                      :src="
                                        post.parent_post_data.posts_images[0].image_path +
                                        '/' +
                                        post.parent_post_data.posts_images[0].image
                                      "
                                      alt=""
                                      v-if="
                                        post.parent_post_data.posts_images[0].type ==
                                        'Image'
                                      "
                                      class="img-thumbnail"
                                      width="100%"
                                      @error="imageNotFound"
                                    />
                                    <!-- style="
                                        height: 400px !important;
                                        width: 100% !important;
                                      " -->
                                    <div
                                      class="embed-responsive embed-responsive-16by9"
                                      v-if="
                                        post.parent_post_data.posts_images[0].type ==
                                        'File'
                                      "
                                      style="height: 250px !important"
                                    >
                                      <iframe
                                        class="embed-responsive-item vue_frame"
                                        :src="
                                          post.parent_post_data.posts_images[0]
                                            .image_path +
                                          '/' +
                                          post.parent_post_data.posts_images[0].image
                                        "
                                      ></iframe>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-else>
                                <div v-if="post.parent_post_data.type == 'Poll'">
                                  <div class="position-relative pt-3 pb-2 pl-3">
                                    <div class="border p-1 box-sha ">
                                      <h6 class="p-1"> {{ post.parent_post_data.question }}</h6>
                                      <div>
                                        <div v-if="!post.parent_post_data.is_voted">
                                          <div v-for="(option, index) in post.parent_post_data.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                            <div @click="postVote(post.parent_post_data.id,option)">{{ option }}</div>
                                          </div>
                                        </div>
                                        <div v-if="post.parent_post_data.is_voted">
                                          <div  v-for="(vote,index) in post.parent_post_data.votes" :key="index">
                                            <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                            <template v-if="((vote/post.parent_post_data.votes_count) * 100).toFixed(2) > 0">
                                              <b-progress :max="100" height="1rem" animated>
                                                <b-progress-bar :value="((vote/post.parent_post_data.votes_count) * 100).toFixed(2)" >
                                                  <strong>{{ ((vote/post.parent_post_data.votes_count) * 100).toFixed(2) }}%</strong>
                                                </b-progress-bar>
                                              </b-progress>
                                            </template>
                                            <template v-else>
                                              <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                <p class="text-center"><strong>0%</strong></p>
                                              </div>
                                            </template>
                                          </div>
                                        </div>
                                        <h6 class="mt-2 vote-count p-1"> {{ post.parent_post_data.votes_count }} Votes</h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ul
                                class="list-inline mt-3"
                                style="display: flex; justify-content: space-between"
                              >
                                <li class="list-inline-item">
                                  <i class="bx bx-like align-middle text-muted me-1"></i>
                                  {{
                                    post.parent_post_data.like_users.length +
                                    post.parent_post_data.like_companies.length +
                                    post.parent_post_data.like_admin.length
                                  }}
                                  Likes
                                </li>
                                <li class="list-inline-item">
                                  <i
                                    class="bx bx-comment-dots align-middle text-muted me-1"
                                  ></i>
                                  {{ post.parent_post_data.comments.length }} Comments
                                </li>
                              </ul>
                            </div>
                        </div>
                        <ul
                          class="list-inline mt-3 mb-0"
                          style="display: flex; justify-content: space-between"
                        >
                          <li class="list-inline-item">
                            <a
                              class="text-muted"
                              href="javascript:void(0)"
                              @click="getToggelData(post.id)"
                              ><i class="bx bx-like align-middle text-muted me-1"></i>
                              {{
                                post.like_users.length +
                                post.like_companies.length +
                                post.like_admin.length
                              }}
                              Likes</a
                            >
                          </li>
                          <li class="list-inline-item">
                            <a
                              class="text-muted"
                              :href="'/company/newsfeeds/show/' + post.id"
                            >
                              <i
                                class="bx bx-comment-dots align-middle text-muted me-1"
                              ></i>
                              {{ post.comments.length }} Comments</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>

                    <hr class="" />

                    <ul
                      class="list-inline text-muted"
                      style="display: flex; justify-content: space-between"
                    >
                      <li
                        class="list-inline-item w-50 likes-post"
                        v-if="post.like_admin.length > 0"
                        style="text-align: center"
                      >
                        <a
                          @click="likes(post.id, 1)"
                          class="text-muted"
                          href="javascript:void(0)"
                        >
                          <i class="bx bxs-like align-middle text-muted me-1 bx-sm"></i>
                        </a>
                      </li>
                      <li
                        class="list-inline-item w-50 likes-post"
                        v-else
                        style="text-align: center"
                      >
                        <a
                          @click="likes(post.id)"
                          class="text-muted"
                          href="javascript:void(0)"
                        >
                          <i class="bx bx-like align-middle text-muted me-1 bx-sm"></i>
                        </a>
                      </li>

                      <li class="list-inline-item w-50" style="text-align: center">
                        <a
                          class="text-muted"
                          href="javascript:void(0)"
                          @click="comments(post.id)"
                        >
                          <i
                            class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <scroll-loader :loader-enable="is_loader" :loaderMethod="loaderMethod">
        </scroll-loader>
      </div>
      <div class="col-lg-8" v-else>
        <div class="card">
          <div class="card-body justify-content-center row">
            <label class="align-middle mt-2">No posts yet</label>
          </div>
        </div>
      </div>
      <b-sidebar
        id="sidebar-rigth"
        title="Likes"
        right
        :visible="showSidebar"
        ref="mySidebar"
        backdrop
        shadow
        @hidden="showSidebar = false"
      >
        <div class="px-3 py-2">
          <b-tabs pills fill content-class="my-4">
            <b-card-text>
              <div>
                <h5 class="font-size-14 mb-3">Users</h5>
                <div style="max-height: 410px">
                  <ul class="list-unstyled chat-list">
                    <li class v-for="data of like_users" :key="data.id">
                      <!-- :class="{ active: username == data.name }" -->
                      <a href="javascript: void(0);">
                        <div class="media">
                          <div class="mr-3" v-if="data.role_id == '2'">
                            <img
                              :src="data.image_path + '/' + data.image"
                              class="rounded-circle avatar-xs"
                              style="height:40px; !important; width:40px !important"
                              alt
                              v-if="data.image"
                              @error="companyimageNotFound"
                            />
                            <img
                              :src="company_image"
                              class="rounded-circle avatar-xs"
                              style="height:40px; !important; width:40px !important"
                              alt
                              v-else
                            />
                          </div>
                          <div class="mr-3" v-else-if="data.role_id == '1'">
                            <img
                              :src="admin_image_url + data.image"
                              class="rounded-circle avatar-xs"
                              style="height:40px; !important; width:40px !important"
                              alt
                              v-if="data.image"
                              @error="companyimageNotFound"
                            />

                            <img
                              :src="company_image"
                              class="rounded-circle avatar-xs"
                              style="height:40px; !important; width:40px !important"
                              alt
                              v-else
                            />
                          </div>
                          <div class="mr-3" v-else>
                            <img
                              :src="data.image_path + '/' + data.image"
                              class="rounded-circle avatar-xs"
                              style="height:40px; !important; width:40px !important"
                              alt
                              v-if="data.image"
                              @error="userimageNotFound"
                            />
                            <img
                              :src="user_image"
                              class="rounded-circle avatar-xs"
                              style="height:40px; !important; width:40px !important"
                              alt
                              v-else
                            />
                          </div>

                          <div class="media-body overflow-hidden">
                            <h5
                              class="text-truncate font-size-14"
                              style="margin-bottom: 0.1px !important"
                            >
                              {{ data.name }}
                            </h5>
                            <span class="badge badge-secondary" v-if="data.role_id == '2'"
                              >company</span
                            >
                            <span
                              class="badge badge-secondary"
                              v-else-if="data.role_id == '1'"
                              >admin</span
                            >
                            <span class="badge badge-secondary" v-else
                              >user {{ data.role_id }}</span
                            >
                            <p class="text-muted mb-0">{{ data.email }}</p>
                          </div>
                          <div class="font-size-11 text-muted">
                            {{ moment(data["pivot"]["created_at"]).fromNow() }}
                          </div>
                        </div>
                      </a>
                      <hr class="mt-1 mb-1" />
                    </li>
                  </ul>
                </div>
              </div>
            </b-card-text>
          </b-tabs>
        </div>
      </b-sidebar>
    </div>
  </Layout>
</template>
<style>
.likes-post:not(:last-child) {
  border-right: 2px solid #e3e4ea !important;
}
.vue_frame {
  height: 250px !important;
}
.repost-border {
  border: 1px solid;
  border-color: #d0d0d0;
}
.options{
  border: 1px solid deepskyblue;
  border-radius: 15px;
  font-size: 15px;
  color: #0face1;
  cursor: pointer;
}
.vote-count{
  color: #0face1;
}
</style>
